import React from 'react';

import AcceptInvite from '../../../banking/components/joint-account-holder/AcceptInvite';

const AcceptCashInviteScreen = () => {
    return <AcceptInvite />;
};

export default AcceptCashInviteScreen;
